var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.getImages),function(image,k){return _c('li',{key:k},[_c('img',{attrs:{"src":image}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }